import { anodum, blocks } from '@yola/ws-sdk';

const isWsBlock = (element) => !!element && anodum.isTag(element, blocks.constants.BLOCK_ID_PREFIX);

export default isWsBlock;
